/* eslint-disable max-len */
export default {
  pollView: {
    fetchingPoll: 'Ładowanie ankiety...',
    okBtnTxtAnswer: 'WSZYSTKO OK (uczestnik kliknął przycisk ;))',
    okBtn: 'Wszystko OK – wyślij najwyższe oceny',
    okBtnCaption: 'Jeśli uważasz, że kurs w 101% spełnia Twoje oczekiwania, nie masz żadnych zastrzeżeń, kliknij ten przycisk! Spowoduje on wysłanie ankiety z najwyższymi ocenami we wszystkich pytaniach ze skalą, na które nie ma jeszcze odpowiedzi. Korzystaj odpowiedzialnie! ;)',
    okDialogTitle: 'Wysłać ankietę z najwyższymi ocenami?',
    okDialogRange: 'Pytania ze skalą, na które nie ma jeszcze odpowiedzi, dostaną najwyższą ocenę: 5 w skali 1–5 i 10 w skali 0–10.',
    okDialogText: 'Puste pola tekstowe zostaną wypełnione tekstem',
    okDialogLowMark: 'Niska ocena wymaga pisemnego uzasadnienia, dlatego pola tekstowe w części z niską oceną trzeba wypełnić samodzielnie.',
    okDialogKeep: 'Odpowiedzi, które już zaznaczono lub wpisano, zostaną bez zmian.',
    okDialogFinal: 'Ankieta zostanie od razu wysłana. Tego nie da się cofnąć.',
    okDialogCancel: 'Anuluj',
    okDialogConfirm: 'Tak, wyślij ankietę',
    save: 'Wyślij ankietę',
    pollNotFound: 'Nie znaleziono ankiety lub ankieta została zarchiwizowana i nie można jej już uzupełnić!',
    answerText: 'Treść odpowiedzi',
    notPresent: 'Nie było mnie na zajęciach',
    fillRequired: 'Odpowiedz na wszystkie pytania ze skalą (1–5 i 0–10).',
    fillRequiredReasons: 'Niska ocena wymaga krótkiego uzasadnienia. Wpisz co najmniej jedną odpowiedź tekstową przy:',
    requiredLegend: 'Pytania oznaczone gwiazdką (*) są wymagane.',
    missingAnswer: 'Zaznacz odpowiedź – to pytanie jest wymagane.',
    lowMarkHint: 'Niska ocena wymaga krótkiego uzasadnienia – napisz tu kilka słów.',
    generalQuestions: 'pytania ogólne',
    unknownTrainer: 'prowadzący',
    savedAnswer: 'Zapisano – tej odpowiedzi nie można już zmienić.',
    pollIsSaved: 'Poprawnie zapisano ankietę. Dziękujemy!',
    pollIsAlreadyFilled: 'Ta ankieta została już wypełniona w tej przeglądarce.',
    savingPoll: 'Zapisywanie ankiety...',
    error: 'Wystąpił błąd podczas zapisywania ankiety! Spróbuj jeszcze raz, a jeśli się nie uda, poinformuj trenera.',
    renderError: 'Nie udało się wyświetlić ankiety. Odśwież stronę, a jeśli problem się powtórzy, poinformuj trenera.',
  },
  loadingMessages: {
    fetchingResources: 'Ładuje zasoby...',
    fetchingAnswers: 'Ładuję odpowiedzi...',
    loadingData: 'Wczytuje dane...',
  },
}
